import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from 'Core/services/loader.service';
import { ToastSeverity } from 'Core/services/toast-service';

@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(
    private loaderService: LoaderService,
    private toastService: ToastSeverity,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.loaderService.showLoader();

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event.type === 4) {
            this.loaderService.hideLoader();
          }
        },
        (error) => {
          this.loaderService.hideLoader();
          // if (error.error?.detail)
          //     this.toastService.showError(error.error.detail);
        },
      ),
    );
  }
}
